import { createAction } from "redux-actions";
import { IImportReport } from "../../api/CourseAuthorApi";
import { IFullCourse } from "../../components/course-author/types";
import {
  IAddListItemPayload,
  IAddOrderItemPayload,
  IChangeListItemAnswersPayload,
  IChooseSingleChoiceAnswerPayload,
  IColumnPayload,
  ISortPartPayload,
} from "./types";

export type IPatchCourseAction =
  | "PATCH_COURSE_REQUEST"
  | "PATCH_COURSE_SUCCESS"
  | "PATCH_COURSE_FAILURE"
  | "PATCH_COURSE_SORT_PART"
  | "PATCH_COURSE_CHOOSE_SINGLE_CHOICE_ANSWER"
  | "PATCH_COURSE_ADD_LIST_ITEM"
  | "PATCH_COURSE_CHANGE_LIST_ITEM_ANSWERS"
  | "PATCH_COURSE_DELETE_IMMERSIVE_BACKGROUND_IMAGE"
  | "PATCH_COURSE_ADD_ORDER_ITEM"
  | "PATCH_COURSE_IMPORT_TRANSLATIONS_CSV"
  | "PATCH_COURSE_IMPORT_TRANSLATIONS_SUCCESS"
  | "PATCH_COURSE_IMPORT_TRANSLATIONS_FAILURE"
  | "PATCH_COURSE_SORT_COLUMN";

export const PATCH_COURSE_REQUEST: IPatchCourseAction = "PATCH_COURSE_REQUEST";
export const PATCH_COURSE_SUCCESS: IPatchCourseAction = "PATCH_COURSE_SUCCESS";
export const PATCH_COURSE_FAILURE: IPatchCourseAction = "PATCH_COURSE_FAILURE";
export const PATCH_COURSE_SORT_COLUMN: IPatchCourseAction = "PATCH_COURSE_SORT_COLUMN";
export const PATCH_COURSE_SORT_PART: IPatchCourseAction = "PATCH_COURSE_SORT_PART";
export const PATCH_COURSE_CHOOSE_SINGLE_CHOICE_ANSWER: IPatchCourseAction = "PATCH_COURSE_CHOOSE_SINGLE_CHOICE_ANSWER";
export const PATCH_COURSE_ADD_LIST_ITEM: IPatchCourseAction = "PATCH_COURSE_ADD_LIST_ITEM";
export const PATCH_COURSE_CHANGE_LIST_ITEM_ANSWERS: IPatchCourseAction = "PATCH_COURSE_CHANGE_LIST_ITEM_ANSWERS";
export const PATCH_COURSE_ADD_ORDER_ITEM: IPatchCourseAction = "PATCH_COURSE_ADD_ORDER_ITEM";
export const PATCH_COURSE_IMPORT_TRANSLATIONS_CSV: IPatchCourseAction = "PATCH_COURSE_IMPORT_TRANSLATIONS_CSV";
export const PATCH_COURSE_IMPORT_TRANSLATIONS_SUCCESS: IPatchCourseAction = "PATCH_COURSE_IMPORT_TRANSLATIONS_SUCCESS";
export const PATCH_COURSE_IMPORT_TRANSLATIONS_FAILURE: IPatchCourseAction = "PATCH_COURSE_IMPORT_TRANSLATIONS_FAILURE";
export const PATCH_COURSE_DELETE_IMMERSIVE_BACKGROUND_IMAGE: IPatchCourseAction =
  "PATCH_COURSE_DELETE_IMMERSIVE_BACKGROUND_IMAGE";

export const patchCourseRequest = createAction<void>(PATCH_COURSE_REQUEST);
export const patchCourseSuccess = createAction<IFullCourse>(PATCH_COURSE_SUCCESS);
export const patchCourseFailure = createAction<string>(PATCH_COURSE_FAILURE);
export const sortPartRequest = createAction<ISortPartPayload>(PATCH_COURSE_SORT_PART);
export const sortColumnRequest = createAction<IColumnPayload>(PATCH_COURSE_SORT_COLUMN);
export const patchCourseChooseSingleChoiceAnswerRequest = createAction<IChooseSingleChoiceAnswerPayload>(
  PATCH_COURSE_CHOOSE_SINGLE_CHOICE_ANSWER
);
export const addListItem = createAction<IAddListItemPayload>(PATCH_COURSE_ADD_LIST_ITEM);
export const changeListItemAnswers = createAction<IChangeListItemAnswersPayload>(PATCH_COURSE_CHANGE_LIST_ITEM_ANSWERS);
export const addOrderItem = createAction<IAddOrderItemPayload>(PATCH_COURSE_ADD_ORDER_ITEM);
export const patchCourseImportTranslationsCsv = createAction<File>(PATCH_COURSE_IMPORT_TRANSLATIONS_CSV);
export const patchCourseImportTranslationsSuccess = createAction<IImportReport>(
  PATCH_COURSE_IMPORT_TRANSLATIONS_SUCCESS
);
export const patchCourseImportTranslationsFailure = createAction<string>(PATCH_COURSE_IMPORT_TRANSLATIONS_FAILURE);
export const patchCourseDeleteImmersiveBackgroundImage = createAction(PATCH_COURSE_DELETE_IMMERSIVE_BACKGROUND_IMAGE);
